import React from "react"
import Link from "next/link"
import { createObjectPagePathname, getMediaUrl } from "@/services/pathname"
import 'moment/locale/fr'
import { getName } from "@/services/aroeven"
import { categories, levels } from "@/services/school"

type CardProps = {
    schoolActivity: SchoolActivity
}

export default function Card({
    schoolActivity
}: CardProps) {

    return (
        <Link className="vignette -type-1 h-100" href={createObjectPagePathname('SchoolActivity', schoolActivity)} >
            <div className="vignette__image">
                <div className="cardImage">
                    <div className="cardImage__content">
                        <img className="col-12" src={getMediaUrl(schoolActivity.media?.url ?? '#')} alt="image" />
                    </div>
                    {schoolActivity.levels.length > 0 &&
                        <div className="cardImage__leftBadge">
                            <div className="tag">
                                <h3 className="tag-title">{schoolActivity.levels.filter(level => level in levels).map(level => levels[level].name).join(', ')}</h3>
                                <div className="tag-tail" />
                            </div>
                        </div>
                    }
                </div>
                <div className="bandeau d-flex justify-content-between">
                    <div>
                        <i className="fi fi-rr-ruler-triangle" /> Activité scolaire
                    </div>
                    {schoolActivity.duration &&
                        <div className="dates">
                            <i className="fi fi-bs-pending mr-5" /> {schoolActivity.duration}
                        </div>
                    }
                </div>
            </div>
            <div className="vignette__content pt-10">
                <div className="d-flex flex-column justify-content-between h-100">
                    <div>
                        <div >
                            <p className="text-light-1 lh-14 text-13 mt-5 mb-0">
                                <i className="fi fi-rr-marker text-primary-4" /> {schoolActivity.thematic.accomodation.address.city} ({schoolActivity.thematic.accomodation.address.postCode.slice(0, 2)})
                            </p>
                        </div>
                        <h4 className="vignette__title py-10">
                            {schoolActivity.name}
                        </h4>
                        <div className="types">
                            {schoolActivity.thematic.categories.filter(category => category in categories).map((category, indexCategory) => {
                                return (
                                    <React.Fragment key={'category-' + indexCategory}>
                                        <div className="type">
                                            {categories[category].name}
                                        </div>
                                    </React.Fragment>
                                )
                            })}
                        </div>
                        <div className="modalite">
                            {schoolActivity.thematic.name}
                        </div>
                    </div>
                    <div>
                        <div className="organisation d-flex items-start">
                            <div className="flex-center size-20 rounded-full bg-primary-3 mr-5 text-white">
                                <i className="fi fi-rr-home" />
                            </div>
                            <div className='lh-1 mb-5'>
                                Organisé par {getName(schoolActivity.thematic.proposedBy)}
                            </div>
                        </div>
                        <div className="partenariat">
                            Centre d'accueil : {schoolActivity.thematic.accomodation.name}
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    )
}